import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, ReplaySubject, switchMap } from 'rxjs';
import { StorageKeys, StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private readonly translateService: TranslateService,
    private readonly storageService: StorageService
  ) {}

  public defaultLanguage: AppLanguage = 'bg';
  public readonly currentLang = new ReplaySubject<AppLanguage>(1);

  setLanguage(lang: AppLanguage = this.defaultLanguage): void {
    this.translateService.setDefaultLang(lang);
    this.translateService
      .use(lang)
      .pipe(
        switchMap(() => this.storageService.set(StorageKeys.LANGUAGE, lang))
      )
      .subscribe(() => {
        this.currentLang.next(lang);
      });
  }

  getSupportedLanguages(): AppLanguage[] {
    return ['en', 'bg'];
  }
}

export type AppLanguage = 'en' | 'bg';
